import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import HomeCategorieDetails from "../../../Components/Modal/supplier_app/HomeIntro/HomeCategorieDetails";

//Redux
import { useSelector } from "react-redux"; //useDispatch
import "./homeIntro.scss";
import CategoryCard from "../../../Components/Cards/CategoryCard";
import StatusDonutChartCard from "../../../Components/Cards/StatusDonutChart";
import StatsGrid from "../../../Components/Cards/StatsGrid";
import ItemService from "../../../services/construction_appCommonService";
import SupplierConstants from "../../../common/SupplierConstants";
import {
  BadgeCheck,
  Ban,
  Building2,
  CheckCircle,
  ClipboardCheck,
  ClipboardList,
  FileEdit,
  MessageCircleQuestion,
  RotateCcw,
  XCircle,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import HomeIntorVideo from "../../../Components/Modal/supplier_app/HomeIntro/HomeIntorVideo";
import SCConstants from "../../../common/SCConstants";
import toast from "react-hot-toast";
import CollapseCard from "../../../Components/Collapsecard/Collapsecard";

const HomeIntro = () => {
  const currentDate = new Date();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Home");
  localStorage.setItem("submenu", "-");
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const firstName = userData?.firstName || "User";

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) return "Good Morning";
    if (hour >= 12 && hour < 17) return "Good Afternoon";
    if (hour >= 17 && hour < 21) return "Good Evening";
    return "Good Night";
  };
  // eslint-disable-next-line no-unused-vars
  const [totalPostDispatchCountStatus, setTotalPostDispatchCountStatus] =
    useState(false);

  const [productdata, setProductdata] = useState({});
  useEffect(() => {
    setProductdata(appConfig?.homeIntro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appConfig]);

  // Format the date (optional)
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // const [getIntroVideo, setIntroVideo] = useState(false);
  const [getCategoryDetail, setCategoryDetail] = useState(false);

  const [getVideoPath, setVideoPath] = useState();

  const [getIntroVideo, setIntroVideo] = useState(false);

  const [getEstimationDraft, setEstimationDraft] = useState("");
  const [getEstimationRevision, setEstimationRevision] = useState("");
  const [getEstimationCreated, setEstimationCreated] = useState("");
  const [getEstimationRevised, setEstimationRevised] = useState("");
  const [getEstimationRejected, setEstimationRejected] = useState("");
  const [getEstimationCanelled, setEstimationCancelled] = useState("");
  // eslint-disable-next-line 
  const [estimationStatusColChartStatus, setEstimationStatusColChartStatus] =
    useState(false);
  // eslint-disable-next-line 
  const [getEstimationPieChart, setEstimationPieChart] = useState("");
  // eslint-disable-next-line 
  const [estimationatusColChart, setEstimationatusColChart] = useState("");

  const introVideoShow = (getVideoPath) => {
    setIntroVideo(true);
    setVideoPath(getVideoPath);
  };

  const attachQueryNames = (filterData) => {
    return {
      ...filterData,
      queryName1: "Yearly_Pie_Estimation_Chart",
      queryName2: "Monthly_Pie_Estimation_Chart",
      queryName:
        filterData.action === "Yearly"
          ? "Yearly_Pie_Estimation_Chart"
          : filterData.action === "Monthly"
            ? "Monthly_Pie_Estimation_Chart"
            : "Custom_Pie_Estimation_Chart",
    };
  };

  const pieChart = async (filterData) => {
    setEstimationStatusColChartStatus(true);

    // Add static + dynamic chart params
    let payload = {
      ...filterData,
      module: "estimation",
      chartType: "doughnut",
    };

    // Attach Yearly / Monthly / Custom query names
    payload = attachQueryNames(payload);

    // API Call
    await ItemService.dashboardHb(payload).then((item) => {
      if (item?.status === 200) {
        item.data.module = "estimation";
        item.data.module = "job";
        item.data.module = "quotation";
        setEstimationPieChart(item?.data);
        // console.log(item?.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setEstimationStatusColChartStatus(false);
  };

  // sum one series data array
  const sumSeries = (seriesItem) => {
    if (!seriesItem?.data) return 0;
    return seriesItem.data.reduce((sum, v) => sum + Number(v || 0), 0);
  };

  // get total by status name from dashboard response
  const getTotalByStatusName = (dashboardData, statusName) => {
    const s = dashboardData?.series?.find((s) => s.name === statusName);
    return sumSeries(s);
  };

  const estimationChart = async (filterData) => {
    setEstimationStatusColChartStatus(true);
    const payload = { ...filterData, module: "estimation", chartType: "bar" };

    try {
      const item = await ItemService.dashboardHb(payload);
      if (item?.status === 200) {
        const data = item.data;
        data.module = "estimation";
        setEstimationatusColChart(data); // existing bar chart state

        // console.log(estimationChart, data);

        // NEW: monthly totals from dashboard series
        const totalDraft = getTotalByStatusName(data, "Estimation Draft");
        const totalCreated = getTotalByStatusName(data, "Estimation Created");
        const totalRevision = getTotalByStatusName(data, "Estimation Revision");
        const totalRevised = getTotalByStatusName(data, "Estimation Rivised");
        const totalRejected = getTotalByStatusName(data, "Estimation Rejected");
        const totalCancelled = getTotalByStatusName(
          data,
          "Estimation Cancelled",
        );

        setEstimationDraft(totalDraft);
        setEstimationCreated(totalCreated);
        setEstimationRevision(totalRevision);
        setEstimationRevised(totalRevised);
        setEstimationRejected(totalRejected);
        setEstimationCancelled(totalCancelled);
      } else {
        toast.error(item?.message || "Please try again for Estimation Chart", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (e) {
      toast.error("Something went wrong in estimation chart", {
        duration: 3000,
        position: "top-right",
      });
    }

    setEstimationStatusColChartStatus(false);
  };

  useEffect(() => {
    let defaultFilter = {
      // action: "Monthly",
      // month: currentMonth,
      // year: currentYear,
      module: "estimation",
      action: "Monthly",
      // month: currentMonth,
      // year: currentYear,
      fromDate: "2025-12-01",
      toDate: "2026-12-20",
      // searchTerm: getemployee?.employeeCode,
      // filterChartField: "userId",
    };
    const defaultFilterPiechart = {
      module: "Estimation",
      action: "Custom",
      chartType: "pie",
      queryName1: "Yearly_Pie_Estimation_Chart",
      queryName2: "Monthly_Pie_Estimation_Chart",
      queryName: "Custom_Pie_Estimation_Chart",
      // month: currentMonth,
      // year: currentYear,
      fromDate: "2025-12-01",
      toDate: "2026-12-29",
    };

    // loadTotalJobCounts();
    // loadEstimationCount();
    // loadQuotationCount();
    //loadEstimationPending(); //estimation pending count
    // loadEnquiryCount();

    // jobsChart(defaultFilter);
    // quotatinChart(defaultFilter);
    estimationChart(defaultFilter);
    pieChart(defaultFilterPiechart);

    //loadEstimationPending(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const introVideoHide = () => {
    setIntroVideo(false);
  };

  let purchaseOrderData = useSelector(
    (state) => state?.purchasing?.purchase_order,
  ); // get purchaseOrderData from Store

  const loadInitialPOData = async () => {
    setData(purchaseOrderData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseOrderData]);

  // eslint-disable-next-line
  const [data, setData] = useState([]);

  const categoryConfigs = [
    {
      title: "Enquiry",
      icon: MessageCircleQuestion,
      fetchFunction: () =>
        ItemService.generateCustomerQuery({
          queryName: "Get_ENQUIRY_LIST",
        }),
      navigateKey: "enq",
    },
    {
      title: "Total Job",
      // queryName: "Get_Quotation_Count_value",
      fetchFunction: () =>
        ItemService.generateCustomerQuery({
          queryName: "Get_JOB_LIST",
        }),
      icon: Building2,
      navigateKey: "job",
    },
    {
      title: "Estimation",
      // queryName: "Get_PO_Count_value",
      fetchFunction: () =>
        ItemService.generateCustomerQuery({
          queryName: "Get_ESTIMATION_LIST",
        }),
      icon: ClipboardList,
      navigateKey: "estimation",
    },
    {
      title: "Quotation",
      fetchFunction: () =>
        ItemService.generateCustomerQuery({
          queryName: "Get_QUOTATION_LIST",
        }),
      icon: ClipboardCheck,
      navigateKey: "qtn",
    },
  ];
  const queryConfigs = [
    {
      title: "Estimation Draft",
      value: getEstimationDraft,
      icon: FileEdit,
      navigateKey: "estimation",
    },

    {
      title: "Estimation Created",
      value: getEstimationCreated,
      icon: CheckCircle,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Revision",
      value: getEstimationRevision,
      icon: RotateCcw,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Revised",
      value: getEstimationRevised,
      icon: BadgeCheck,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Rejected",
      value: getEstimationRejected,
      icon: XCircle,
      navigateKey: "estimation",
    },
    {
      title: "Estimation Canceled",
      value: getEstimationCanelled,
      icon: Ban,
      navigateKey: "estimation",
    },
  ];

  const navigateToMainPage = (page) => {
    if (page === "supplier") {
      navigate(SupplierConstants.SUPPILER_LIST);
    } else if (page === "job") {
      navigate(SCConstants.CONSTRUCTION_JOB_LIST);
    } else if (page === "enq") {
      navigate(SCConstants.CONSTRUCTION_ENTRY_LIST);
    } else if (page === "estimation") {
      navigate(SCConstants.CONSTRUCTION_ESTIMATE_SPECIFICATION_LIST);
    } else if (page === "qtn") {
      navigate(SCConstants.CONSTRUCTION_QUOTATION_LIST);
    }
  };

  const [statusCountData, setStatusCountData] = useState([]);

  const loadTotalStatusCount = async () => {
    let obj = {
      queryName: "getSupplier_StatusChartList",
      chartCategory: "status",
    };
    try {
      await ItemService.generateChartQuery(obj).then((item) => {
        if (item?.status === 200) {
          setStatusCountData(item?.data);
        } else {
          console.error("Failed to Status Count");
        }
      });
    } catch (error) {
      console.log("Failed to Status Count", error);
    }
  };

  useEffect(() => {
    loadTotalStatusCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line no-unused-vars
  const categoryDetailShow = () => {
    // setCategoryDetail(true);
  };

  const categoryDetailHide = () => {
    setCategoryDetail(false);
  };

  const ProductSection = ({ data }) => {
    return (
      <Row className="homeintroposter">
        {/* Product Info Section */}
        <Col
          xs={12}
          md={12}
          lg={12}
          className="postertext d-flex justify-content-center align-items-center flex-column mb-4"
        >
          <p className="fw-bold ms-2 fs-3">{data?.mainTitle}</p>
          <div className="smarthub">
            <p className="fs-5 fw-bold ms-2">{data?.subTitle}</p>
          </div>
        </Col>
        {/* Loop through products */}

        {data?.products?.map((product, index) => (
          <Col
            key={index}
            xs={12}
            md={2}
            lg={2}
            className="d-flex flex-column align-items-center p-2"
          >
            <div className="image-box d-flex justify-content-center align-items-center">
              <img
                className="img-fluid"
                src={product?.image}
                alt={product?.alt}
              />
            </div>
            <p className="fs-5 fw-bold m-0">{product?.name}</p>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <main className="dashboard main customer" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row className="home-intro">
              <Col xs={12} md={12} lg={12} className="headers p-2 mb-2">
                <Row className="align-items-center">
                  {/* LEFT SECTION */}
                  <Col xs={12} md={3}>
                    <h4 className="greeting">
                      <span className="morningText">{getGreeting()}</span>,{" "}
                      <span className="userName">{firstName}</span> 👋
                    </h4>
                    <h5 className="welcome">
                      Welcome to{" "}
                      <span className="portal">Smart Construction</span>
                    </h5>
                  </Col>

                  {/* CENTER SECTION */}
                  <Col xs={12} md={7} className="text-center">
                    <div className="d-flex justify-content-center align-items-center">
                      {appConfig?.customerLogo1 && (
                        <img
                          className="img-fluid introCustomerlogo"
                          src={appConfig?.customerLogo1}
                          alt="logo1"
                        />
                      )}

                      <p className="fw-bold ms-2 fs-2 mb-0">
                        {appConfig?.customerName}
                      </p>

                      {appConfig?.customerLogo2 && (
                        <img
                          className="img-fluid ms-2"
                          src={appConfig?.customerLogo2}
                          alt="logo2"
                        />
                      )}
                    </div>
                  </Col>

                  {/* RIGHT SECTION (DATE AT END) */}
                  <Col xs={12} md={2} className="d-flex justify-content-end">
                    <div className="date">
                      <InputField
                        className="inputBox"
                        value={formattedDate}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <div className="col-lg-12 px-0 mb-1">
                <CollapseCard title="">
                    {/* <h5 className="card-title mb-3">My Category</h5> */}
                    <div className="row g-3">
                      {categoryConfigs.map((item, index) => (
                        <div
                          className="col-12 col-md-6 col-lg-3 px-2 py-0"
                          key={index}
                        >
                          <CategoryCard
                            {...item}
                            onClick={() => navigateToMainPage(item.navigateKey)}
                          />
                        </div>
                      ))}
                    </div>
                 </CollapseCard>
              </div>
              <div className="col-lg-12 px-0 mb-1">
               <CollapseCard title="">
                    <div className="row g-3 mt-0 align-items-start">
                      {/* LEFT DONUT CHART */}
                      <div className="col-12 col-lg-4 d-flex">
                        <StatusDonutChartCard
                          title="Supplier Statics"
                          data={statusCountData}
                          className="w-100 h-100"
                        />
                      </div>

                      {/* RIGHT STATS GRID */}
                      <div className="col-12 col-lg-8 d-flex">
                        <div className="card w-100 h-100">
                          <div className="card-body p-0">
                            <StatsGrid
                              queryConfigs={queryConfigs}
                              refreshInterval={30000}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
               </CollapseCard>
              </div>
              <Col xs={12} md={12} lg={12} className="mb-2">
                <ProductSection data={productdata} />
              </Col>
              <Col xs={12} md={12} lg={12} className="headers mb-0 mt-0">
                <p className="title p-2">Process</p>
                <div className="d-flex overflow-auto mb-0 mt-0">
                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Vendor Management</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Procurement</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-file-earmark-check"></i>
                          </div>
                          <h5 className="card-title">Sourcing</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-card-list"></i>
                          </div>
                          <h5 className="card-title">Contract</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Auction</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/Spend_Analysis.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Spend Analysis</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* <HomeIntorVideo show={getIntroVideo} onHide={introVideoHide} videopath={getVideoPath} /> */}
      <HomeCategorieDetails
        show={getCategoryDetail}
        onHide={categoryDetailHide}
      />
      <HomeIntorVideo
        show={getIntroVideo}
        onHide={introVideoHide}
        videopath={getVideoPath}
      />
    </main>
  );
};
export default HomeIntro;
